import React, { useEffect, useState } from "react";
import Image from "next/image";
import Link from "next/link";
import { fetchCountryCode } from "lib/utils/getCountryCode";

export const PremiumBanner: React.FC = () => {
  const [countryCode, setCountryCode] = useState("IN");
  useEffect(() => {
    fetchCountryCode(setCountryCode);
  }, []);
  const price = countryCode === "IN" ? "₹69" : "$9";
  return (
    <div className="flex w-full justify-center">
      <div
        className="relative flex items-center px-6"
        style={{
          height: "73px",
          background: "#0045D9",
          borderRadius: "12px",
          boxShadow: "0 8px 20px rgba(0,0,0,0.18)",
          overflow: "visible",
        }}
      >
        {/* Left promo badge */}
        <div
          className="mr-8 flex items-center"
          style={{
            // width: "132px",
            height: "55px",
            borderRadius: "10px",
            boxShadow:
              "0 4px 0 rgba(0,0,0,0.06) inset, 0 6px 14px rgba(0,0,0,0.12)",
            background:
              "linear-gradient(135deg, #FFFFFF 0%, #EAF1FF 17%, #FFFFFF 29%, #EAF1FF 52%, #FFFFFF 66%, #EAF1FF 79%, #FFFFFF 89%)",
            padding: "10px 14px",
          }}
        >
          <div className="flex flex-col justify-center">
            <div className="text-[14px] font-semibold leading-[18px] text-[#222]">
              Get Premium
            </div>
            <div className="text-[9px] font-medium leading-[16px] text-[#222]">
              Starts at{" "}
              <span className="text-[16px] font-semibold text-[#2a56d6]">{price}</span>{" "}
              Only
            </div>
          </div>
        </div>

        {/* Features list */}
        <div className="flex flex-1 items-center gap-6">
          <div className="flex items-center gap-1.5">
            <div className="flex h-[34px] w-[34px] items-center justify-center rounded-full bg-white">
              <Image
                src="/icons/resume-icon.svg"
                alt="Resume"
                width={20}
                height={20}
              />
            </div>
            <div className="text-white">
              <div className="text-[12px] font-semibold leading-[15px]">
                Resume analysis
              </div>
              <div className="text-[11px] leading-[13px]">and score check</div>
            </div>
          </div>

          <div className="flex items-center gap-1.5">
            <div className="flex h-[34px] w-[34px] items-center justify-center rounded-full bg-white">
              <Image
                src="/icons/save-icon.svg"
                alt="Save"
                width={20}
                height={20}
              />
            </div>
            <div className="text-[12px] font-semibold leading-[15px] text-white">
              Save unlimited resumes
            </div>
          </div>

          <div className="flex items-center gap-1.5">
            <div className="flex h-[34px] w-[34px] items-center justify-center rounded-full bg-white">
              <Image
                src="/icons/ad-free.svg"
                alt="Ad Free"
                width={20}
                height={20}
              />
            </div>
            <div className="text-[12px] font-semibold leading-[15px] text-white">
              AD Free Experience
            </div>
          </div>
        </div>

        {/* Right Subscribe button */}
        <div className="ml-3">
          <Link href="/premium-subscription">
            <button
              style={{
                background:
                  "linear-gradient(90deg, #5866FB 0%, #7D86E3 49%, #5865FB 100%)",
                border: "4px solid rgba(255,255,255,0.9)",
                borderRadius: "22px",
                padding: "8px 16px",
              }}
              className="text-[14px] font-semibold leading-[18px] text-white shadow-sm"
            >
              Subscribe Now
            </button>
          </Link>
        </div>
      </div>
    </div>
  );
};

export default PremiumBanner;
